const InfoCommon = require('od-modules/helpers/map/info/info_common');
const INFO_WINDOW_CLASS = '.gm-style-iw';
const INFO_WINDOW_OPTIONS = {
    offset: {
        posX: -2,
        posY: 0,
    },
    offsetMapHorizontal: 0,
    offsetMapVertical: -140,
};

function InfoWindow(map, libMap, options) {
    InfoCommon.call(this, map, libMap, options);
    this.infoWindow = new this.libMap.InfoWindow();
    this.maxWidth = options.infoWindowMaxWidth;
    this.setCommonOptions(options.infoWindowOptions || {});
    this.bindCommonEvents();
}

InfoWindow.prototype = Object.create(InfoCommon.prototype);
InfoWindow.prototype.constructor = InfoWindow;

InfoWindow.prototype.getDiv = function() {
    const map = this.infoWindow.getMap();

    return map instanceof this.libMap.Map ? $(map.getDiv()).find(INFO_WINDOW_CLASS).get(0) : null;
};

InfoWindow.prototype.refresh = function() {
    this.map.setCenter(this.getSelectedMarker().getPosition());
    this.map.panBy(INFO_WINDOW_OPTIONS.offsetMapHorizontal, INFO_WINDOW_OPTIONS.offsetMapVertical);
    this.setCommonOptions(this.getSelectedMarker().options.infoWindowOptions);
};

InfoWindow.prototype.getDefaultOptions = function(options) {
    const offset = Odigeo._.get(options, 'offset', INFO_WINDOW_OPTIONS.offset);

    return Odigeo._.extend({}, {
        maxWidth: this.maxWidth,
        pixelOffset: new this.libMap.Size(offset.posX, offset.posY),
    }, options);
};

module.exports = InfoWindow;
